
export default {
	props: {
		img: {
			type: String,
			default: ''
		}
	}
}
